import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';
import { CommonModule } from '@angular/common';
import { MainRoutingModule } from './main-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// AM Modules
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';

// Components
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';
import { PaymentComponent } from './payment/payment.component';
import { SelectPageComponent } from '../main/select-page/select-page.component';
import { StartDemoComponent } from './start-demo/start-demo.component';
import { EventoComponent } from './evento/evento.component';
import { CentroComercialComponent } from './centro-comercial/centro-comercial.component';
import { AlmacenComponent } from './almacen/almacen.component';
import { ListaCentrosComercialesComponent } from './lista-centros-comerciales/lista-centros-comerciales.component';
import { ListaEventosComponent } from './lista-eventos/lista-eventos.component';
import { ListaNoticiasComponent } from './lista-noticias/lista-noticias.component';
import { ConfirmationPaymentComponent } from './confirmation-payment/confirmation-payment.component';
import { AccountComponent } from './account/account.component';
import { EventoFeriaComponent } from './evento-feria/evento-feria.component';
import { ExpoferiaComponent } from './expoferia/expoferia.component';
import { HomeAuthComponent } from './home-auth/home-auth.component';
import { EventoConferenciaComponent } from './evento-conferencia/evento-conferencia.component';
import { EventoFeriaEscolarComponent } from './evento-feria-escolar/evento-feria-escolar.component';
import { EventoFeriaPersonalizadaComponent } from './evento-feria-personalizada/evento-feria-personalizada.component';
import { EventoYincanaComponent } from './evento-yincana/evento-yincana.component';
import { ConferenciaComponent } from './conferencia/conferencia.component';
import { FeriaEscolarComponent } from './feria-escolar/feria-escolar.component';
import { FeriaPersonalizadaComponent } from './feria-personalizada/feria-personalizada.component';
import { YincanaComponent } from './yincana-ar/yincana-ar.component';
import { StatisticsComponent } from './statistics/statistics.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    HomeComponent,
    ProfileComponent,
    PaymentComponent,
    ConfirmationPaymentComponent,
    StartDemoComponent,
    EventoComponent,
    SelectPageComponent,
    CentroComercialComponent,
    AlmacenComponent,
    ListaCentrosComercialesComponent,
    ListaEventosComponent,
    ListaNoticiasComponent,
    AccountComponent,
    EventoFeriaComponent,
    ExpoferiaComponent,
    HomeAuthComponent,
    EventoConferenciaComponent,
    EventoFeriaEscolarComponent,
    EventoFeriaPersonalizadaComponent,
    ConferenciaComponent,
    FeriaEscolarComponent,
    FeriaPersonalizadaComponent,
    StatisticsComponent,
    EventoYincanaComponent,
    YincanaComponent
  ],
  imports: [
    CoreModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MainRoutingModule,
    MatTableModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatDatepickerModule,
    MatStepperModule,
    MatIconModule,
    MatCheckboxModule,
    MatSelectModule,
    MatButtonModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatDialogModule,
    MatExpansionModule,
  ],
})
export class MainModule {}
